import { usePolicies } from '../../api/queries/usePolicies';
import { CenterAlignedContainer } from '../CenterAlignedContainer';

import { ProductSleeve } from './ProductSleeve';
import styles from './styles.module.css';

interface ItemListProps {
  className?: string;
}
export const ProductList: React.FC<ItemListProps> = () => {
  const { data: items = [] } = usePolicies();

  return (
    <CenterAlignedContainer className={styles.outer}>
      <div className={styles.container}>
        <div className={styles.itemList}>
          {items.map((item) => (
            <ProductSleeve key={item.id} {...item} />
          ))}
        </div>
      </div>
    </CenterAlignedContainer>
  );
};
